// Add child route into children of submenu to highlight menu when visit
export default {
  meta: {
    public: false,
    auth: true,
    icon: "fa-desktop",
    expanded: false,
    label: "Storefront",
    permission: [
      config.permission.STOREFRONT_INDEX
    ]
  },
  children: [
    {
      name: "general_settings",
      path: "/setting/general",
      meta: {
        label: "General",
        permission: [config.permission.SETTINGS_INDEX]
      },
      component: () => import("views/setting/setting/index_general")
    },

    {
      name: "Create Banner",
      path: "/setting/appearance/shop_banner/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [
          {
            name: "Shop Banner",
            link: "/setting/appearance?tab=shop_banner"
          },
          { name: "Create" }
        ]
      },
      component: () => import("views/shop_banners/create"),
      props: true
    },
    {
      name: "Edit Banner",
      path: "/setting/appearance/shop_banner/edit/:id",
      meta: {
        auth: true,
        label: "Edit ",
        breadcrumb: [
          { name: "Shop Banner", link: "/setting/appearance?tab=shop_banner" }
        ]
      },
      component: () => import("views/shop_banners/edit")
    },
    {
      name: "Appearance",
      path: "/setting/appearance",
      meta: {
        label: "Appearance",
        permission: [config.permission.APPEARANCE_INDEX]
      },
      component: () => import("views/setting/appearance/index")
    },
    {
      name: "slider_edit",
      path: "/setting/appearance/slider/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Slider", link: "/setting/appearance?tab=slider" }]
      },
      component: () => import("views/setting/appearance/slider/update")
    },
    {
      name: "slider_duplicate",
      path: "/setting/appearance/slider/duplicate/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Slider", link: "/setting/appearance?tab=slider" }]
      },
      component: () => import("views/setting/appearance/slider/duplicate")
    },
    {
      name: "Post",
      path: "/post",
      meta: {
        label: "Posts",
        permission: [config.permission.POSTS_INDEX]
      },
      component: () => import("views/post/index")
    },
    {
      name: "TagPost",
      path: "/post_type",
      meta: {
        label: "Post Types",
        breadcrumb: [{ name: "Post Types" }],
        permission: [config.permission.POST_TAGS_INDEX]
      },
      component: () => import("views/post/tag/index")
    },
    {
      name: "CategoryPost",
      path: "/post_category",
      meta: {
        label: "Post Categories",
        breadcrumb: [{ name: "Post Categories" }],
        permission: [config.permission.POST_CATEGORIES_INDEX]
      },
      component: () => import("views/post/category/index")
    },
    {
      name: "post_create",
      path: "/post/create",
      meta: {
        auth: true,
        label: "Create Post",
        breadcrumb: [{ name: "Create", link: "/post?" }]
      },
      component: () => import("views/post/create")
    },
    {
      name: "post_edit",
      path: "/post/edit/:id",
      meta: { auth: true, label: "Post", breadcrumb: [{ link: "/post?" }] },
      component: () => import("views/post/edit")
    },
    // Post category
    {
      name: "catepost_create",
      path: "/post_category/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [
          { name: "Post Categories", link: "/post_category" },
          { name: "Create" }
        ]
      },
      component: () => import("views/post/category/create")
    },
    {
      name: "catepost_edit",
      path: "/post_category/edit/:id",
      meta: {
        auth: true,
        label: "Edit",
        breadcrumb: [{ name: "Post Categories", link: "/post_category" }]
      },
      component: () => import("views/post/category/update")
    },
    // Post type
    {
      name: "tagpost_create",
      path: "/post_type/create",
      meta: {
        auth: true,
        label: "Create",
        breadcrumb: [
          { name: "Post Types", link: "/post_type" },
          { name: "Create" }
        ]
      },
      component: () => import("views/post/tag/create")
    },
    {
      name: "tagpost_edit",
      path: "/post_type/edit/:id",
      meta: {
        auth: true,
        label: "Post Tag",
        breadcrumb: [{ name: "Post Types", link: "/post_type" }]
      },
      component: () => import("views/post/tag/update")
    }
  ]
};
